'use es6';

import { Fragment } from 'react';
import { List } from 'immutable';
import PropTypes from 'prop-types';
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { isEmailCMF } from 'conversations-message-history/common-message-format/operators/cmfComparators';
import { hasTextContent } from 'conversations-message-history/web/common-message/operators/hasTextContent';
import { hasImageContent } from 'conversations-message-history/web/common-message/operators/hasImageContent';
import { getFilteredAttachments, hasRenderableAttachments } from 'conversations-message-history/attachments/operators/imageAttachmentFilters';
import InlineAttachments from '../attachments/InlineAttachments';
import { getQuickRepliesAttachment } from 'conversations-message-history/attachments/operators/quickRepliesAttachmentGetters';
import QuickRepliesAttachment from '../attachments/QuickRepliesAttachment';
import { getMessageHeaderAttachment } from 'conversations-message-history/attachments/operators/headerAttachmentGetters';
import WorkflowGeneratedUserHeaderAttachment from '../workflow-generated-user-message/components/WorkflowGeneratedUserHeaderAttachment';
import { getContentAttachments, getMessageDirection, getGenericChannelId } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
import { INCOMING } from 'conversations-message-history/common-message-format/constants/messageDirections';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CommonMessageSection = props => {
  const {
    message,
    fileAttachments = List(),
    renderMessageContent
  } = props;
  const headerAttachment = getMessageHeaderAttachment(message);
  //remove header attachment from rest of the attachments
  const contentAttachments = getContentAttachments(message, fileAttachments);
  const quickRepliesAttachment = getQuickRepliesAttachment(message);
  const messageDirection = getMessageDirection(message);
  const genericChannelId = getGenericChannelId(message);
  const shouldRenderContent = hasTextContent(message) || hasImageContent(message) || headerAttachment || quickRepliesAttachment;
  const renderQuickReplies = () => {
    if (!quickRepliesAttachment || messageDirection === INCOMING) {
      return null;
    }
    return /*#__PURE__*/_jsx(QuickRepliesAttachment, {
      quickRepliesAttachment: quickRepliesAttachment
    });
  };
  const renderMessageHeaderAttachment = () => {
    if (!headerAttachment) {
      return null;
    }
    return /*#__PURE__*/_jsx(WorkflowGeneratedUserHeaderAttachment, {
      headerAttachment: headerAttachment,
      fileAttachments: fileAttachments,
      genericChannelId: genericChannelId
    });
  };
  const shouldRenderInlineAttachments = !isEmailCMF(message) && hasRenderableAttachments(contentAttachments);
  if (!shouldRenderInlineAttachments && !shouldRenderContent) {
    return null;
  }
  const renderableAttachments = shouldRenderInlineAttachments && getFilteredAttachments({
    fileAttachments: contentAttachments,
    canRender: true
  });
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [renderMessageHeaderAttachment(), renderMessageContent(), renderQuickReplies(), shouldRenderInlineAttachments && /*#__PURE__*/_jsx(InlineAttachments, {
      fileAttachments: renderableAttachments
    })]
  });
};
CommonMessageSection.displayName = 'CommonMessageSection';
CommonMessageSection.propTypes = {
  fileAttachments: PropTypes.instanceOf(List),
  message: RecordPropType('CommonMessage').isRequired,
  renderMessageContent: PropTypes.func.isRequired
};
export default CommonMessageSection;